import { isSome } from './typeguards';
/**
 * The goal is to allow the broadest possible set of valid emails
 * while still enforcing some basic rules.
 * The best way to validate an email is to try and send an email to it.
 * Since we can't do that, we'll use a regular expression to check for some basic rules.
 * This pattern enforces:
 * - Local part (before @): must not start/end with a dot, no consecutive dots
 * - Domain part (after @): must not start/end with a dot, no consecutive dots
 * - TLD: at least 2 characters
 * - No whitespace or multiple @ symbols
 * @example `user@domain.com` -> pass
 * @example `user.name@sub.domain.com` -> pass
 * @example `.user@domain.com` -> fail (starts with dot)
 * @example `user.@domain.com` -> fail (ends with dot before @)
 * @example `user..name@domain.com` -> fail (consecutive dots)
 * @example `user@domain..com` -> fail (consecutive dots in domain)
 * @example `user @domain.com` -> fail (whitespace)
 * @example `user@dom@ain.com` -> fail (multiple @)
 * @example `user@domain.a` -> fail (TLD only has 1 character)
 */
const VALID_EMAIL = /^[^\s@.]+(?:\.[^\s@.]+)*@[^\s@.]+(?:\.[^\s@.]+)*\.[^\s@.]{2,}$/;
export function isValidEmail(email) {
  return isSome(email) && VALID_EMAIL.test(email);
}